import { Box, Fade, Slide, Typography, TypographyProps } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

const messages = [
  'Harvesting a garden of customer insights 🌱',
  '🧬 Extracting the DNA of customer insights',
  'Baking a rich cake of customer feedback layers 🍰',
  '🎨 Painting a masterpiece of customer insights',
  '🧠 Brainstorming a storm of customer insights',
  '🔮 Predicting the future of customer insights',
  'Turning feedback into a treasure trove of wisdom 💎',
];

interface GenerateSummaryLoaderAnimatedTextProps {
  variant?: TypographyProps['variant'];
}

export function GenerateSummaryLoaderAnimatedText({
  variant = 'body1',
}: GenerateSummaryLoaderAnimatedTextProps) {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const containerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const intervalTimer = setInterval(() => {
      setCurrentTextIndex((index) => (index + 1) % messages.length);
    }, 4000);

    return () => clearInterval(intervalTimer);
  }, []);

  return (
    <Box ref={containerRef} sx={{ height: '30px' }}>
      {messages.map((message, index) => (
        <Slide
          container={containerRef.current}
          appear={false}
          in={index === currentTextIndex}
          timeout={{ enter: 0, exit: 1000 }}
          style={{ position: 'absolute' }}
          key={`${message}${index}`}
        >
          <Box component="span">
            <Fade
              in={index === currentTextIndex}
              timeout={{ enter: 100, exit: 1000 }}
            >
              <Typography variant={variant}>{message}</Typography>
            </Fade>
          </Box>
        </Slide>
      ))}
    </Box>
  );
}
